<div class="mb-3" *ngIf="label">
  <label class="form-label">
    {{ label }}
    <span *ngIf="required" class="text-danger ms-1">*</span>
  </label>
</div>

<div #wrapperEl class="is-autocomplete" [class.is-autocomplete--open]="isOpen" [class.is-autocomplete--error]="hasError">
  <!-- Input -->
  <div class="is-autocomplete__input-wrapper">
    <i *ngIf="prefixIcon" [class]="'bx ' + prefixIcon + ' is-autocomplete__prefix'"></i>
    <input
      #inputEl
      type="text"
      class="is-autocomplete__input"
      [class.is-autocomplete__input--with-icon]="prefixIcon"
      [placeholder]="placeholder"
      [disabled]="isDisabled"
      [(ngModel)]="searchTerm"
      (input)="onInput()"
      (keydown)="onKeydown($event)"
      autocomplete="off"
    >
    <button
      *ngIf="searchTerm"
      type="button"
      class="is-autocomplete__clear"
      (click)="clear()"
    >
      <i class="bx bx-x"></i>
    </button>
  </div>

  <!-- Dropdown -->
  <ul *ngIf="isOpen" class="is-autocomplete__dropdown" role="listbox">
    <li
      *ngFor="let option of filteredOptions; let i = index"
      class="is-autocomplete__option"
      [class.is-autocomplete__option--highlighted]="i === highlightedIndex"
      role="option"
      (click)="selectOption(option)"
      (mouseenter)="highlightedIndex = i"
    >
      <i *ngIf="option.icon" [class]="'bx ' + option.icon + ' is-autocomplete__option-icon'"></i>
      <div class="is-autocomplete__option-text">
        <span class="is-autocomplete__option-label">{{ option.label }}</span>
        <span *ngIf="option.description" class="is-autocomplete__option-desc">{{ option.description }}</span>
      </div>
    </li>
  </ul>
</div>

<small *ngIf="helpText && !hasError" class="form-text text-muted">{{ helpText }}</small>
<is-form-error *ngIf="control" [control]="control"></is-form-error>
